export const getMeta = (meta) => {
    return meta ? meta : [];
}